const DomainCrawlScheduleListColumn = [
  {
    title: 'No.',
    dataIndex: 'index',
    width: 50,
  },
  {
    title: 'Domain',
    dataIndex: 'name',
    slot: 'name',
    width: 250,
  },
  {
    title: 'Schedule Start Date',
    dataIndex: 'start_date',
    slot: 'start_date',
    width: 100,
  },
  {
    title: 'Last Crawl Date',
    dataIndex: 'last_run_date',
    slot: 'last_run_date',
    width: 100,
  },
  {
    title: 'Crawl Interval',
    dataIndex: 'interval',
    slot: 'interval',
    width: 100,
  },
  {
    title: 'Crawl URL',
    dataIndex: 'seed_url',
    slot: 'seed_url',
    width: 200,
  },
  {
    title: 'Crawl Depth',
    dataIndex: 'depth',
    slot: 'depth',
    width: 100,
  },
  {
    title: 'Policy',
    dataIndex: 'policy_id',
    slot: 'policy_id',
    width: 100,
  },
  {
    title: '',
    dataIndex: '',
    width: 50,
    slot: 'operation',
  },
];

export { DomainCrawlScheduleListColumn };
